import { fss } from "../fable_modules/Fss-lib.Fable.1.0.3/FssFable.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library.3.7.17/Seq.js";
import { ColorClass_Color__hex_Z721C83C5, ColorClass_Color__get_black, ColorClass_Color__get_white } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Color.fs.js";
import { BackgroundColor } from "../fable_modules/Fss-lib.Core.1.0.4/css/Background.fs.js";
import { Color } from "../fable_modules/Fss-lib.Core.1.0.4/css/Color.fs.js";
import { BorderBottomWidth, BorderBottomStyle, BorderBottomColor, BorderRightWidth, BorderRightStyle, BorderRightColor } from "../fable_modules/Fss-lib.Core.1.0.4/css/Border.fs.js";
import { BorderClasses_BorderStyleParent__get_solid } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Border.fs.js";
import { unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B, unitHelpers_DirectionalLength__value_Z498FEB3B } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Units.fs.js";
import { sec, vh, px } from "../fable_modules/Fss-lib.Core.1.0.4/Functions.fs.js";
import { Height, Width, MinWidth, MinHeight } from "../fable_modules/Fss-lib.Core.1.0.4/css/ContentSize.fs.js";
import { TransitionDuration__value_74CCD5DD, TransitionProperty__get_width } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Transition.fs.js";
import { TransitionTimingFunction, TransitionDuration, TransitionProperty } from "../fable_modules/Fss-lib.Core.1.0.4/css/Transition.fs.js";
import { AnimationClasses_AnimationTimingFunction__get_ease } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Animation.fs.js";
import { OverflowClasses_OverflowClass__get_hidden } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Overflow.fs.js";
import { Overflow } from "../fable_modules/Fss-lib.Core.1.0.4/css/Overflow.fs.js";
import { VisibilityClasses_Opacity__value_5E38073B } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Visibility.fs.js";
import { Opacity } from "../fable_modules/Fss-lib.Core.1.0.4/css/Visibility.fs.js";
import { FlexClasses_JustifyContent__get_start } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Flex.fs.js";
import { FlexWrap, JustifyContent } from "../fable_modules/Fss-lib.Core.1.0.4/css/Flex.fs.js";
import { center, appBarLogo, spaceBetween, flexExpand, alignCenter, hideInPrint, fullWidth, PaddingBottom as PaddingBottom_1, PaddingTop as PaddingTop_1, PaddingRight, PaddingLeft, Var } from "../../../Styles/Utils.fs.js";
import { empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.17/List.js";
import { CssRuleWithNone__get_none, CssRule__get_initial } from "../fable_modules/Fss-lib.Core.1.0.4/Types/MasterTypes.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import ListItem from "@material-ui/core/ListItem";
import { Feliz_prop__prop_fss_Static_72C268A9 } from "../fable_modules/Fss-lib.Feliz.1.0.3/FssFeliz.fs.js";
import { PaddingBottom, PaddingTop } from "../fable_modules/Fss-lib.Core.1.0.4/css/Padding.fs.js";
import Button from "@material-ui/core/Button";
import { join } from "../fable_modules/fable-library.3.7.17/String.js";
import { RouterModule_urlSegments, RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { useReact_useEffect_Z101E1A95, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { equals } from "../fable_modules/fable-library.3.7.17/Util.js";
import { Page, quotes, attestenFinaliseren, beschikbaarheden, adis, syndics, partners, myDossiers, dossiers, customers, availability, placeDescriptionAppointments, appointments, dashboard, appRouter } from "../AppRoutes.fs.js";
import { createElement } from "react";
import * as react from "react";
import Dashboard from "@material-ui/icons/Dashboard";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import Event$ from "@material-ui/icons/Event";
import EventAvailable from "@material-ui/icons/EventAvailable";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import Work from "@material-ui/icons/Work";
import PermContactCalendar from "@material-ui/icons/PermContactCalendar";
import Contacts from "@material-ui/icons/Contacts";
import CalendarToday from "@material-ui/icons/CalendarToday";
import ImportContacts from "@material-ui/icons/ImportContacts";
import WorkOutline from "@material-ui/icons/WorkOutline";
import Divider from "@material-ui/core/Divider";
import { Auth0UserPrivileges, Auth0UserClaims__HasPrivilege_6B2F319B } from "../../../shared/Auth0Constants.fs.js";
import { Row, Col } from "../../../Components/UtilComponents.fs.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useUsername, useToggle } from "../../../CustomHooks/CustomHooks.fs.js";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import AppBar_1 from "@material-ui/core/AppBar";
import { BoxShadow } from "../fable_modules/Fss-lib.Core.1.0.4/css/BoxShadow.fs.js";
import Toolbar from "@material-ui/core/Toolbar";
import { logo } from "../Img.fs.js";
import ExitToApp from "@material-ui/icons/ExitToApp";

export const drawerWidth = 195;

export function drawerStyle(isOpen) {
    return fss(toList(delay(() => append(singleton(ColorClass_Color__get_white(BackgroundColor)), delay(() => append(singleton(ColorClass_Color__get_black(Color)), delay(() => append(singleton(ColorClass_Color__hex_Z721C83C5(BorderRightColor, "f0f0f0")), delay(() => append(singleton(BorderClasses_BorderStyleParent__get_solid(BorderRightStyle)), delay(() => append(singleton(unitHelpers_DirectionalLength__value_Z498FEB3B(BorderRightWidth, px(1))), delay(() => append(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(MinHeight, vh(100))), delay(() => append(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(MinWidth, px(220))), delay(() => append(singleton(TransitionProperty__get_width(TransitionProperty)), delay(() => append(singleton(TransitionDuration__value_74CCD5DD(TransitionDuration, sec(0.2))), delay(() => append(singleton(AnimationClasses_AnimationTimingFunction__get_ease(TransitionTimingFunction)), delay(() => append(singleton(OverflowClasses_OverflowClass__get_hidden(Overflow)), delay(() => (isOpen ? append(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(Width, px(drawerWidth))), delay(() => singleton(VisibilityClasses_Opacity__value_5E38073B(Opacity, 1)))) : singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(Width, px(40)))))))))))))))))))))))))))));
}

export const menuButtonStyle = fss(ofArray([FlexClasses_JustifyContent__get_start(JustifyContent), ColorClass_Color__hex_Z721C83C5(Color, Var.Colors.TextLight)]));

export const menuButtonActive = fss(singleton_1(ColorClass_Color__hex_Z721C83C5(Color, "#548d00")));

export const flexNoWrap = fss(singleton_1(CssRule__get_initial(FlexWrap)));

export const cornerStyle = fss(singleton_1(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(Height, px(89))));

export function MenuButton(menuButtonInputProps) {
    let elems;
    const active = menuButtonInputProps.active;
    const url = menuButtonInputProps.url;
    const icon = menuButtonInputProps.icon;
    const text = menuButtonInputProps.text;
    return MuiHelpers_createElement(ListItem, [["key", text], ["disableGutters", true], Feliz_prop__prop_fss_Static_72C268A9(toList(delay(() => append(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(PaddingTop, px(0))), delay(() => append(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(PaddingBottom, px(0))), delay(() => (active ? singleton(ColorClass_Color__hex_Z721C83C5(BackgroundColor, "f0f0f0")) : empty())))))))), (elems = [MuiHelpers_createElement(Button, [["className", join(" ", toList(delay(() => append(singleton(menuButtonStyle), delay(() => append(singleton(PaddingLeft.M), delay(() => append(singleton(PaddingRight.M), delay(() => append(singleton(PaddingTop_1.M), delay(() => append(singleton(PaddingBottom_1.M), delay(() => (active ? singleton(menuButtonActive) : empty()))))))))))))))], ["onClick", (_arg) => {
        RouterModule_nav(ofArray(url), 1, 1);
    }], ["startIcon", icon], ["fullWidth", true], ["children", text]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]);
}

export function Menu(auth0User) {
    const patternInput = useFeliz_React__React_useState_Static_1505(void 0);
    const currentPage = patternInput[0];
    const isActivePage = (page) => {
        if (currentPage == null) {
            return false;
        }
        else {
            return equals(currentPage, page);
        }
    };
    useReact_useEffect_Z101E1A95(() => {
        patternInput[1](appRouter(RouterModule_urlSegments(window.location.hash, 1)));
    }, [window.location.hash]);
    let dashboardLink;
    let icon;
    const props = {};
    icon = react.createElement(Dashboard, props);
    const url = Page$2__toUrl_2B594(dashboard);
    dashboardLink = ((active) => createElement(MenuButton, {
        text: "Dashboard",
        icon: icon,
        url: url,
        active: active,
    }));
    let appointmentsLink;
    let icon_1;
    const props_1 = {};
    icon_1 = react.createElement(Event$, props_1);
    const url_1 = Page$2__toUrl_2B594(appointments);
    appointmentsLink = ((active_1) => createElement(MenuButton, {
        text: "Afspraken",
        icon: icon_1,
        url: url_1,
        active: active_1,
    }));
    let placeDescriptionsLink;
    let icon_2;
    const props_2 = {};
    icon_2 = react.createElement(Event$, props_2);
    const url_2 = Page$2__toUrl_2B594(placeDescriptionAppointments);
    placeDescriptionsLink = ((active_2) => createElement(MenuButton, {
        text: "Plaatsbeschrijving",
        icon: icon_2,
        url: url_2,
        active: active_2,
    }));
    let availabilityLink;
    let icon_3;
    const props_3 = {};
    icon_3 = react.createElement(EventAvailable, props_3);
    const url_3 = Page$2__toUrl_2B594(availability);
    availabilityLink = ((active_3) => createElement(MenuButton, {
        text: "Beschikbaarheid",
        icon: icon_3,
        url: url_3,
        active: active_3,
    }));
    let customersLink;
    let icon_4;
    const props_4 = {};
    icon_4 = react.createElement(PeopleAlt, props_4);
    const url_4 = Page$2__toUrl_2B594(customers);
    customersLink = ((active_4) => createElement(MenuButton, {
        text: "Klanten",
        icon: icon_4,
        url: url_4,
        active: active_4,
    }));
    let dossiersLink;
    let icon_5;
    const props_5 = {};
    icon_5 = react.createElement(Work, props_5);
    const url_5 = Page$2__toUrl_2B594(dossiers);
    dossiersLink = ((active_5) => createElement(MenuButton, {
        text: "Dossiers",
        icon: icon_5,
        url: url_5,
        active: active_5,
    }));
    let myDossiersLink;
    let icon_6;
    const props_6 = {};
    icon_6 = react.createElement(Work, props_6);
    const url_6 = Page$2__toUrl_2B594(myDossiers);
    myDossiersLink = ((active_6) => createElement(MenuButton, {
        text: "Mijn Dossiers",
        icon: icon_6,
        url: url_6,
        active: active_6,
    }));
    let partnersLink;
    let icon_7;
    const props_7 = {};
    icon_7 = react.createElement(PermContactCalendar, props_7);
    const url_7 = Page$2__toUrl_2B594(partners);
    partnersLink = ((active_7) => createElement(MenuButton, {
        text: "Partners",
        icon: icon_7,
        url: url_7,
        active: active_7,
    }));
    let syndicsLink;
    let icon_8;
    const props_8 = {};
    icon_8 = react.createElement(PermContactCalendar, props_8);
    const url_8 = Page$2__toUrl_2B594(syndics);
    syndicsLink = ((active_8) => createElement(MenuButton, {
        text: "Syndics",
        icon: icon_8,
        url: url_8,
        active: active_8,
    }));
    let adisLink;
    let icon_9;
    const props_9 = {};
    icon_9 = react.createElement(Contacts, props_9);
    const url_9 = Page$2__toUrl_2B594(adis);
    adisLink = ((active_9) => createElement(MenuButton, {
        text: "ADIs",
        icon: icon_9,
        url: url_9,
        active: active_9,
    }));
    let avialabilityAdis;
    let icon_10;
    const props_10 = {};
    icon_10 = react.createElement(CalendarToday, props_10);
    const url_10 = Page$2__toUrl_2B594(beschikbaarheden);
    avialabilityAdis = ((active_10) => createElement(MenuButton, {
        text: "Beschikbaarheden",
        icon: icon_10,
        url: url_10,
        active: active_10,
    }));
    let finalizeLink;
    let icon_11;
    const props_11 = {};
    icon_11 = react.createElement(ImportContacts, props_11);
    const url_11 = Page$2__toUrl_2B594(attestenFinaliseren);
    finalizeLink = ((active_11) => createElement(MenuButton, {
        text: "Finaliseren",
        icon: icon_11,
        url: url_11,
        active: active_11,
    }));
    let quotesLink;
    let icon_12;
    const props_12 = {};
    icon_12 = react.createElement(WorkOutline, props_12);
    const url_12 = Page$2__toUrl_2B594(quotes);
    quotesLink = ((active_12) => createElement(MenuButton, {
        text: "Offertes VME",
        icon: icon_12,
        url: url_12,
        active: active_12,
    }));
    const newLinks = toList(delay(() => append(singleton(dashboardLink(isActivePage(new Page(1)))), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => append(singleton(createElement("div", {})), delay(() => append(Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(0)) ? append(singleton(avialabilityAdis(isActivePage(new Page(30)))), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(createElement("div", {})))))) : empty(), delay(() => append(Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(0)) ? append(singleton(customersLink(isActivePage(new Page(2)))), delay(() => singleton(dossiersLink(isActivePage(new Page(14)))))) : empty(), delay(() => append((Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(0)) ? true : Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(1))) ? append(singleton(appointmentsLink(isActivePage(new Page(26)))), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(createElement("div", {})))))) : empty(), delay(() => append(Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(1)) ? append(singleton(myDossiersLink(isActivePage(new Page(15)))), delay(() => append(singleton(finalizeLink(isActivePage(new Page(29)))), delay(() => append(singleton(availabilityLink(isActivePage(new Page(19)))), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(createElement("div", {})))))))))) : empty(), delay(() => (Auth0UserClaims__HasPrivilege_6B2F319B(auth0User, new Auth0UserPrivileges(0)) ? append(singleton(adisLink(isActivePage(new Page(10)))), delay(() => append(singleton(partnersLink(isActivePage(new Page(6)))), delay(() => append(singleton(syndicsLink(isActivePage(new Page(33)))), delay(() => append(singleton(quotesLink(isActivePage(new Page(38)))), delay(() => singleton(MuiHelpers_createElement(Divider, [])))))))))) : empty())))))))))))))))));
    return createElement(Col, {
        classes: empty_1(),
        children: newLinks,
    });
}

export function AppBar(appBarInputProps) {
    let elems_4, elements, elems_2, props_7;
    const children = appBarInputProps.children;
    const auth0User = appBarInputProps.auth0User;
    const auth = useAuth0();
    const drawerOpen = useToggle(true);
    const username = useUsername();
    return createElement(Row, {
        classes: ofArray([fullWidth, flexNoWrap]),
        children: ofArray([createElement(Col, {
            classes: ofArray([drawerStyle(drawerOpen.State), hideInPrint]),
            children: ofArray([createElement(Row, {
                classes: singleton_1(cornerStyle),
                children: singleton_1(createElement(Row, {
                    classes: singleton_1(alignCenter),
                    children: toList(delay(() => {
                        let elems, props, elems_1, props_2;
                        return drawerOpen.State ? singleton(MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
                            drawerOpen.Off();
                        }], (elems = [(props = {}, react.createElement(ChevronLeft, props))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])) : singleton(MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
                            drawerOpen.On();
                        }], (elems_1 = [(props_2 = {}, react.createElement(ChevronRight, props_2))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]));
                    })),
                })),
            }), MuiHelpers_createElement(Divider, []), createElement(Menu, auth0User)]),
        }), createElement(Col, {
            classes: singleton_1(flexExpand),
            children: ofArray([MuiHelpers_createElement(AppBar_1, [["style", {
                backgroundColor: "#FFFFFF",
            }], Feliz_prop__prop_fss_Static_72C268A9(ofArray([CssRuleWithNone__get_none(BoxShadow), ColorClass_Color__hex_Z721C83C5(BorderBottomColor, "f0f0f0"), BorderClasses_BorderStyleParent__get_solid(BorderBottomStyle), unitHelpers_DirectionalLength__value_Z498FEB3B(BorderBottomWidth, px(1))])), ["classes.root", hideInPrint], ["position", "sticky"], (elems_4 = [MuiHelpers_createElement(Toolbar, [["classes.root", spaceBetween], (elements = [createElement("img", {
                className: appBarLogo,
                alt: "We Check Logo",
                src: logo,
            }), createElement(Row, {
                classes: singleton_1(center),
                children: ofArray([createElement("b", {
                    style: {
                        color: "#000000",
                    },
                    children: username,
                }), MuiHelpers_createElement(IconButton, [["color", "primary"], ["onClick", (_arg_2) => {
                    auth.logout();
                }], (elems_2 = [(props_7 = {}, react.createElement(ExitToApp, props_7))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])]),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]), createElement(Row, {
                classes: empty_1(),
                children: children,
            })]),
        })]),
    });
}

